import { AppSettings } from "@core/types";

export const Config: AppSettings = {
  exitAppICantGoBack: true,
  isOffertaPageEnabled: false,
  haveTabs: true,
  baseUrl: "https://api.irskom.ru",
  CDNDomain: "irskom.ru",
  sharedData: {
    title: "Ирском",
    text: "Ирском - сеть магазинов и пунктов выдачи заказов\n\n",
    androidUrl: "https://play.google.com/store/apps/details?id=ru.irskom.app",
    iosUrl: "https://apps.apple.com/us/app/irskom/id6451446579",
  },
  image: {
    isDownSizeEnabled: true,
    isLazyLoadingEnabled: true,
    base64Extension: "jpeg",
    isNeedBase65Prefix: true,
    isBase64InSrc: true,
  },
  lowStockThresholdToShowPercent: 10,
  minLowStockThresholdToShowNumber: 10,
  showStockQuantity: false,
  minimumOrderAmount: 0,
  newProductDuration: 20,
  shouldCheckItemsAvailability: false,
  showNewVersionAlert: false,
  wishListIcons: true,

  showProductReviews: false,
  showCouponsInCart: false,

  isBonusPointsEnabled: false,
  shipping: {
    isShippingZonesEnabled: false,
    showDefaultShippingZone: false,
    showOldAddressInputOnShippingPage: true,
    showCurrentShippingAddressSelect: false,
  },
  isDeliveryDateEnabled: false,
  orderHistoryPagination: false,
  isCustomerAdressesEnabled: false,
  isReferralEnabled: false,

  deleteAccountLink: "",
  showSendCustomerRequestButton: false,

  signUpPage: {
    nameFieldEnabled: true,
    lastNameFieldEnabled: true,
  },

  // deleteAccountLink: "https://parhato.ru/delete-me/",
  // showSendCustomerRequestButton: true,
  cardProduct: false,
  updateUserForm: {
    isUpdatePasswordEnabled: false,
    showPhoneNumberInput: false,
  },
  isOnlinePaymentEnabled: true,
  privacyPolicyPageLink: "https://irskom.ru/privacy.html",
  isSeoOnHomePageEnabled: false,
  companyPhoneNumber: "+7 (928) 888-10-10",
  isContentInFooterShown: false,
  hasCardLoyalty: true,
  showSliderCatalogButton: false,
  addressSettings: {
    showCustomerAddresses: false,
    showFlatDelivery: false,
    addressInputDependsOnShippingMethod: true,
  },
  homePageCategories: {
    customersChoice: { title: "Customers Choice", isEnabled: false },
    featured: { title: "Bestsellers", isEnabled: true },
    sale: { title: "Good price", isEnabled: true },
    latest: { title: "Latest Addest", isEnabled: true },
  },
  showOrderPageProductCardCounter: true,
  cartMinAmountFromMethods: false,
  siteDomain: "irskom.ru",

  loginPage: {
    phoneOrEmailFieldEnabled: false,
  },

  orderDetailPage: {
    repeatOrderEnabled: false,
    reviewOrderEnabled: false,
  },
  expressMaxWeightKg: 0,
  isExpressDeliveryEnabled: false,
  search: {
    minSearchLength: 3,
    inputDebounceTimeMs: 500,
  },

  appIosId: "6451446579",
  headquarters: [43.318995, 45.685574],
  isNecessaryToCreateAddress: false,
  contacts: [
    { title: "Основной телефон:", url: "tel:89288881010", contact: "8 928 888 10 10" },
    { title: "Сайт:", url: "tel:89288881010", contact: "8 928 888 10 10" },
    { title: "Для юридических лиц:", url: "tel:89280850888", contact: "8 928 085 08 88" },
    { title: "Для поставщиков:", url: "tel:89389907117", contact: "8 938 990 71 17" },
    { title: "Трудоустройство:", url: "tel:89298882822", contact: "8 929 888 28 22" },
    { title: "Реклама и сотрудничество:", url: "tel:89389907227", contact: "8 938 990 72 27" },
  ],
  requisites: [
    "ИП Мусаев Алихан Алиевич",
    "ИНН 201600591641 / ОГРНИП 309203103400036",
    "Юридический адрес: 364024 Чеченская Республика г.Грозный ул. Р. Люксембург д.30",
  ],
  isUnavailableProductsEnabled: false,
  customerSurvey: {
    isEnabled: false,
    allowDismiss: true,
  },
  isStoriesEnabled: false,
  isInviteEnabled: false,

  hasClientToDeleteUser: false,
  isCardsEnabled: false,
  pages: {
    authPageName: "common",
    homePageName: "common",
    myOrdersPageName: "common",
    searchMainCategoriesPageName: "common",
    cartPageName: "common",
    myAccountPageName: "common",
    thankYouPageName: "common",
    subCategoriesPageName: "common",
    orderDetailPageName: "common",
    wishlistPageName: "common",
    productDetailPageName: "common",
  },
  isPaymentsEnabled: false,
  isSettingsPageEnabled: false,
  isEmailPushEnabled: false,
  isCartProgressButtonEnabled: false,
  isCartQuantityInputEnabled: false,
  isWeightProductQuantityStepEnabled: false,
  showUnavailableProductsModal: true,
  isImageInCartStoreEnabled: false,
  isShouldRecalculatePriceOnReplace: false,
  isToggleSwitchModuleEnabled: false,
  isCartSyncEnabled: false,
  showStockStatus: false,
  shareProduct: false,
  showParentName: false,
  isDeliveryIntervalEnabled: true,
  isLocalNotificationsEnabled: false,
  isFCMNotificationsEnabled: false,
  staticOrderDataEnabled: false,
  isReferralStatsEnabled: false,
  isAdditionalPageEnabled: false,
  expressAllowedTimeStart: "10:00",
  expressAllowedTimeEnd: "23:59",
  appMetrica: {
    enabled: false,
    apiKey: "",
  },
  maxWeightFeeStep: 10,
  maxWeightForFeeKG: 0,
  extraWeightFee: 0,
  isWeightFeeEnabled: false,
  isOrderChatEnabled: true,
  stepForWeightProductQuantity: 0.1,
};
